export default {
  mounted(el) {
    console.log(el);
  },
};
